/**
 * @generated SignedSource<<7689ffc5a6efc5f8be85f199abac7514>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DownloadReportsPopupButton_project$data = {
  readonly name: string;
  readonly team: {
    readonly pricingModel: string;
  };
  readonly " $fragmentType": "DownloadReportsPopupButton_project";
};
export type DownloadReportsPopupButton_project$key = {
  readonly " $data"?: DownloadReportsPopupButton_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"DownloadReportsPopupButton_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DownloadReportsPopupButton_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pricingModel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectInterface",
  "abstractKey": "__isProjectInterface"
};

(node as any).hash = "9e2689076d4c87a5659d791d476f4d11";

export default node;
